<template>
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3700_13307)">
            <path
                d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                fill="#E7EEF1"
            />
            <g clip-path="url(#clip1_3700_13307)">
                <path
                    d="M23.6107 15.6894C23.6107 20.8405 19.4299 25.0213 14.2788 25.0213C9.12775 25.0213 4.9469 20.8468 4.9469 15.6894C4.9469 10.532 9.12775 6.35748 14.2788 6.35748C15.4533 6.35748 16.5767 6.5745 17.6107 6.97025"
                    stroke="#011837"
                    stroke-miterlimit="10"
                />
                <path
                    d="M23.2851 6.42126L14.8723 14.834L11.3617 11.3298L8.55957 14.1319L14.8723 20.4447L26.0872 9.22339L23.2851 6.42126Z"
                    fill="#6BFFFF"
                    stroke="#011837"
                    stroke-miterlimit="10"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_3700_13307">
                <rect width="30" height="30" fill="white" />
            </clipPath>
            <clipPath id="clip1_3700_13307">
                <rect
                    width="22.2957"
                    height="19.7553"
                    fill="white"
                    transform="translate(4.46814 5.74469)"
                />
            </clipPath>
        </defs>
    </svg>
</template>